module.exports = __webpack_public_path__ + "static/media/5.739d0afb.jpg";